import { castDraft, produce } from "immer";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { ParametricReducer, RecordType, TypedObject } from "@multiweb/types/react";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    IDataSourceData,
    ILoadDataSuccessAction,
    IRefreshDataAction,
    IRefreshDataSuccessAction,
    RecordIdKeyType,
} from "../types";
import { getRecordId } from "../utils";

const records: ParametricReducer<TypedObject<RecordType>, string> = (
    state = DATA_SOURCE_INIT_STATE.data.records,
    action,
    recordIdKey,
) => {
    if (action instanceof ILoadDataSuccessAction || action instanceof IRefreshDataSuccessAction) {
        return produce(state, (draft) => {
            action.payload.data.forEach((record) => {
                if (draft[getRecordId(record, recordIdKey)] === undefined) {
                    // Záznam se vloží pouze pokud již nebyl načtený.
                    draft[getRecordId(record, recordIdKey)] = record;
                }
            });
        });
    } else if (action instanceof IRefreshDataAction) {
        return EMPTY_OBJECT;
    }
    return state;
};

const recordsIds: ParametricReducer<ReadonlyArray<string>, string> = (
    state = DATA_SOURCE_INIT_STATE.data.recordsIds,
    action,
    recordIdKey,
) => {
    if (action instanceof ILoadDataSuccessAction) {
        return produce(state, (draft) => {
            const { data } = action.payload;
            const mappedIds = data.map((record) => getRecordId(record, recordIdKey));
            const idSet = new Set([...draft, ...mappedIds]);
            return [...idSet];
        });
    } else if (action instanceof IRefreshDataAction) {
        return EMPTY_ARRAY;
    } else if (action instanceof IRefreshDataSuccessAction) {
        const { data } = action.payload;
        return data.map((record) => getRecordId(record, recordIdKey));
    }
    return state;
};

export const dataReducer: ParametricReducer<IDataSourceData, RecordIdKeyType> = (
    state = DATA_SOURCE_INIT_STATE.data,
    action,
    recordIdKey,
) => {
    return produce(state, (draft) => {
        const recordsState = records(draft.records, action, recordIdKey);
        const recordsIdsState = recordsIds(draft.recordsIds, action, recordIdKey);

        draft.records = recordsState;
        draft.recordsIds = castDraft(recordsIdsState);
    });
};
